import React from "react";
import {
  Grid,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Stack,
} from "@mui/material";

import AppStoreImage from "../../../assets/Images/app_store.png";
import GooglePlayImage from "../../../assets/Images/google_play.png";
import Mobile from "../../../assets/Images/mobile.png";
import { isMobile } from "react-device-detect";

const MobileApp = () => {
  return (
    <div className="mt-10 pt-16 pb-16">
      <Grid container spacing={6} alignItems="center">
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          style={
            isMobile
              ? { width: "100%", marginLeft: "20px" }
              : {
                  width: "45%",
                  marginLeft: "5%",
                }
          }
        >
          <Typography
            style={{
              fontSize: "48px",
              lineHeight: "56px",
              fontWeight: "700",
              color: "#18191A",
            }}
          >
            Download our Mobile <br /> Application!
          </Typography>
          <Typography
            className="mt-10"
            style={{
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "400",
              color: "#18191A",
            }}
          >
            Hire smoothly and stay updated with your bookings with our <br />{" "}
            mobile application that can be easily downloaded from:
          </Typography>
          <Stack
            className="mt-10"
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <a href="#" title="Google Play">
              <img
                src={AppStoreImage}
                alt="App Store"
                style={{ width: "203px", height: "60px" }}
              />
            </a>
            <a href="#" title="Google Play">
              <img
                src={GooglePlayImage}
                alt="Google Play"
                style={{ width: "203px", height: "60px" }}
              />
            </a>
          </Stack>
        </Grid>
        <Grid item>
          <img
            src={Mobile}
            style={
              isMobile
                ? { width: "400px", height: "500px", objectFit: "contain" }
                : null
            }
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default MobileApp;
